<div class="dashboard-container animated fadeIn">
  <div class="row">
    <ng-container *ngFor="let dashboardWidget of dashboardWidgets">
      <div
        *ngIf="dashboardWidget | displayWidgetUsingPermissions"
        [ngClass]="{
          'col-sm-6 col-md-6 col-lg-6 col-xl-3': dashboardWidget?.widget?.widgetSize === widgetSize.Small,
          'col-sm-12 col-md-12 col-lg-6 col-xl-6': dashboardWidget?.widget?.widgetSize === widgetSize.Large
        }"
        class="sortable-column"
      >
        <div class="sortable-portlet">
          <hb-gauge
            *ngIf="dashboardWidget.widget.widgetDisplayType === widgetDisplayType.Gauge"
            [dashboardWidget]="dashboardWidget"
            [data]="dashboardWidget.widget.data"
            [colour]="widgetsSettings | widgetSettings: dashboardWidget.widgetId:'colour'"
            [showActions]="isTrue"
            [sortable]="isTrue"
          ></hb-gauge>

           <hb-bar
            *ngIf="dashboardWidget.widget.widgetDisplayType === widgetDisplayType.Bar"
            [dashboardWidget]="dashboardWidget"
            [title]="dashboardWidget.title"
            [widgetId]="dashboardWidget.dashboardWidgetId"
            [data]="dashboardWidget.widget.data"
            [colour]="widgetsSettings | widgetSettings: dashboardWidget.widgetId:'colour'"
            [drillDownRoute]="widgetsSettings | widgetSettings: dashboardWidget.widgetId:'drillDownRoute'"
            [drillDownFilters]="widgetsSettings | widgetSettings: dashboardWidget.widgetId:'drillDownFilters'"
            [showActions]="isTrue"
            [sortable]="isTrue"
          ></hb-bar>

          <hb-line
            *ngIf="dashboardWidget.widget.widgetDisplayType === widgetDisplayType.Line"
            [dashboardWidget]="dashboardWidget"
            [title]="dashboardWidget.title"
            [widgetId]="dashboardWidget.dashboardWidgetId"
            [data]="dashboardWidget.widget.data"
            [showActions]="isTrue"
            [sortable]="isTrue"
          ></hb-line>
        </div>
      </div>
    </ng-container>
    <div class="col-sm-6 col-lg-3">
      <div class="card dashed-panel-hoverable" (click)="addWidget()" title="Add a widget">
        <i class="fa fa-plus fa-5x" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</div>
